import { render, staticRenderFns } from "./datepicker.vue?vue&type=template&id=81d4da68&scoped=true"
import script from "./datepicker.js?vue&type=script&lang=js&external"
export * from "./datepicker.js?vue&type=script&lang=js&external"
import style0 from "./datepicker.vue?vue&type=style&index=0&id=81d4da68&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d4da68",
  null
  
)

export default component.exports